export const Loaders = () => {
    return <div className="loader-overlay">
        <div className="loader"></div>
    </div>
}